import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/partners/partners.component').then(
        m => m.PartnersComponent,
      ),
  },
  {
    path: 'openforge',
    loadComponent: () =>
      import(
        './components/partners-openforge/partners-openforge.component'
      ).then(m => m.PartnersOpenforgeComponent),
  },
];
